import React, { useState } from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import { toast } from 'sonner';

const AdminLogin = () => {
  const { user, loading, login } = useAuth();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [isSubmitting, setIsSubmitting] = useState(false);

  if (loading) {
    return <div className="min-h-screen bg-black flex items-center justify-center"><div className="text-white/40">Loading...</div></div>;
  }

  if (user) {
    return <Navigate to="/admin" replace />;
  }

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);
    try {
      await login(email, password);
      toast.success('Login successful');
    } catch (err) {
      const detail = err.response?.data?.detail;
      const msg = typeof detail === 'string' ? detail : 'Login failed';
      toast.error(msg);
    } finally {
      setIsSubmitting(false);
    }
  };

  const inputClass = "w-full px-5 py-4 bg-white/5 border border-white/10 rounded text-white placeholder-white/25 focus:outline-none focus:border-[#17B9BE]/50 transition-colors text-sm";

  return (
    <div className="min-h-screen bg-black flex items-center justify-center px-4" data-testid="admin-login-page">
      <div className="w-full max-w-md">
        <div className="text-center mb-10">
          <h1 className="font-display text-3xl font-bold mb-3">Admin Panel</h1>
          <p className="text-white/40 text-sm">Sign in to manage your content</p>
        </div>

        <form onSubmit={handleSubmit} className="bg-[#0a0a0a] p-8 rounded border border-white/5" data-testid="admin-login-form">
          <div className="mb-5">
            <label className="block text-xs uppercase tracking-wider text-white/40 mb-2">Email</label>
            <input type="email" data-testid="admin-email-input" value={email} onChange={(e) => setEmail(e.target.value)} className={inputClass} required />
          </div>
          <div className="mb-6">
            <label className="block text-xs uppercase tracking-wider text-white/40 mb-2">Password</label>
            <input type="password" data-testid="admin-password-input" value={password} onChange={(e) => setPassword(e.target.value)} className={inputClass} required />
          </div>
          <button type="submit" data-testid="admin-login-button" disabled={isSubmitting}
            className="w-full px-8 py-4 brand-gradient-bg text-black font-semibold rounded-sm hover:opacity-90 transition-all disabled:opacity-50 text-sm uppercase tracking-wider">
            {isSubmitting ? 'Signing in...' : 'Sign In'}
          </button>
        </form>
      </div>
    </div>
  );
};

export default AdminLogin;
